import { colors } from '../../Colors/colors'

export const whatsappIntegrations = {
   light: {
      common: {
         closeIconBGColor: colors['gray-500'],
         defaultBGColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         defaultDescriptionColor: 'text-gray-600',
         defaultIconFillColor: colors['primary-600'],
         defaultTextColor: 'text-gray-900',
         modalButtonBGColor: '!bg-transparent',
         whatsappIntegrationsBGColor: 'bg-gray-100',
         backIconColor: colors['gray-700']
      },
      createWhatsappPluginAccount: {
         defaultDescriptionColor: 'text-gray-600',
         defaultTextColor: 'text-gray-900',
         readRecipientsTextColor: 'text-gray-700'
      },
      whatsappPluginDetailsTable: {
         phoneNumberTextColor: 'text-gray-800',
         tableCellDataColor: 'text-gray-600',
         tableCellNameColumnColor: 'text-gray-600',
         tableColumnHeaderColor: 'text-gray-500',
         tableContainerBgColor: 'bg-gray-100',
         whatsappIntegrationsBGColor: 'bg-gray-100',
         defaultIconFillColor: colors['primary-600']
      },
      whatsAppNumbers: {
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-700',
         tableCellDataColor: 'text-gray-600',
         tableCellNameColumnColor: 'text-gray-600',
         tableColumnHeaderColor: 'text-gray-500',
         tableContainerBgColor: 'bg-gray-100',
         tooltipBGColor: 'bg-gray-900'
      },
      detailedViewHeader: {
         chevronLeftIconFillColor: colors['primary-600'],
         headerBgColor: 'bg-base-white',
         headerBorderColor: 'border-gray-200',
         headerTitleColor: 'text-gray-900',
         backIconColor: colors['gray-700']
      },
      templateCard: {
         bgColor: 'bg-base-white',
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         templateTitleColor: 'text-gray-900'
      },
      templatesList: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-700',
         noDataTitleColor: 'text-gray-900',
         noDataDescriptionColor: 'text-gray-600'
      },
      expandableCard: {
         cardBgColor: 'bg-white',
         cardTitleColor: 'text-gray-700',
         cardDescriptionColor: 'text-gray-600',
         cardIconColor: colors['gray-600']
      },
      createOrUpdateWhatsappNumber: {
         headerTextColor: 'text-gray-900',
         sidePaneBorderColor: 'border-gray-300',
         errorTextColor: 'text-error-500',
         errorIconFillColor: colors['error-500'],
         transparentBGColor: 'bg-transparent',
         onHoverDeleteOptionBGColor: 'hover:bg-gray-50'
      },
      editMessageTemplate: {
         plusIconFillColor: colors['blue-600'],
         popoverTriggerIconColor: colors['gray-700'],
         popoverTriggerHoverColor: 'hover:bg-gray-50',
         popoverBorderColor: 'border-gray-200',
         trashIconColor: colors['error-600'],
         deleteTextColor: 'text-error-700',
         disabledPickerBgColor: 'bg-gray-100',
         tickIconColor: colors['primary-600'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedPipelineBGColor: 'bg-primary-50',
         disabledIconColor: colors['gray-300'],
         variableNameColor: 'text-gray-700'
      },
      configurations: {
         cardBgColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-700',
         fieldLabelColor: 'text-gray-700',
         fieldDescriptionColor: 'text-gray-600'
      },
      phoneNumberFilter: {
         filterIconColor: colors['primary-600'],
         textColor: 'text-gray-900',
         hoverBgColor: 'hover:bg-gray-50',
         selectedBgColor: 'bg-gray-50'
      },
      userCard: {
         cardHoverColors: 'hover:bg-gray-50',
         alertIconColor: colors['error-600']
      }
   },
   dark: {}
}
